<template>
    <b-overlay :show="loading">
        <b-row class="justify-content-center">
            <b-col lg="9" md="10" sm="12">
                <b-card class="mb-2">
                    <div class="d-flex justify-content-end">
                        <a
                            v-if="qrCode"
                            :href="qrCode"
                            :download="`QR Code ${asset.nama || 'asset'}`"
                            class="btn btn-info"
                        >
                            Download
                        </a>
                    </div>
                    <div class="w-100 d-flex flex-column" id="qrcode-container" v-if="qrCode">
                        <div class="d-flex justify-content-center mb-1">
                            <button
                                type="button"
                                class="asset-qr-thumb btn btn-link p-0 border-0"
                                title="Klik untuk memperbesar (scan)"
                                @click="showQrModal = true"
                            >
                                <img :src="qrCode" class="d-block" alt="QR Code" />
                            </button>
                        </div>
                        <p class="text-center text-muted small mb-0">Klik QR untuk memperbesar</p>
                    </div>
                    <div class="d-flex justify-content-center mb-3 mt-1">
                        <b-button
                            variant="outline-secondary"
                            class="mr-1"
                            @click.prevent="reloadQrCode"
                        >
                            Muat Ulang QR Code
                        </b-button>
                        <b-button
                            v-if="qrCode"
                            variant="info"
                            @click.prevent="printQrCode"
                        >
                            Cetak
                        </b-button>
                    </div>
                    <table class="table">
                        <tr>
                            <td>Nama Aset</td>
                            <th>{{ asset ? asset.nama : '' }}</th>
                        </tr>
                        <tr>
                            <td>Kode</td>
                            <th>{{ asset ? asset.kode : '' }}</th>
                        </tr>
                        <tr>
                            <td>Jenis Aset</td>
                            <th>
                                <div v-if="asset">
                                    {{ asset.jenis == 1 ? 'TETAP' : 'BHP' }}
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <td>Kategori</td>
                            <th>
                                <div v-if="asset">
                                    {{ asset.kategori ? asset.kategori.kategori : '' }}
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <td>Jumlah</td>
                            <th>{{ asset ? asset.jumlah : '' }}</th>
                        </tr>
                        <tr>
                            <td>Harga Dasar </td>
                            <th>Rp {{ asset ? formatRupiah(asset.harga_dasar) : 0 }}</th>
                        </tr>
                        <tr>
                            <td>Keterangan</td>
                            <th>{{ asset ? asset.keterangan : '' }}</th>
                        </tr>
                        <tr>
                            <td>Satuan</td>
                            <th>
                                <div v-if="asset">
                                    {{ asset.satuan ? asset.satuan.satuan : '' }}
                                </div>
                            </th>
                        </tr>
                    </table>
                </b-card>
            </b-col>
        </b-row>

        <b-modal
            v-model="showQrModal"
            title="QR Code Aset"
            size="md"
            centered
            hide-footer
            body-class="text-center"
        >
            <img
                v-if="qrCode"
                :src="qrCode"
                class="asset-qr-full d-block mx-auto"
                alt="QR Code full size"
            />
            <p class="text-muted small mt-1 mb-0">Arahkan kamera ke QR untuk scan</p>
        </b-modal>
    </b-overlay>
</template>
<script>
import {BButton, BOverlay, BRow, BCol, BCard, BModal} from 'bootstrap-vue'
export default {
    components: {
        BButton, BOverlay, BRow, BCol, BCard, BModal
    },
    data: () => ({
        loading: false,
        asset: {},
        qrCode: null,
        showQrModal: false,
    }),
    methods: {
        async printQrCode() {
            const asset_id = this.$route.params.id
            this.loading = true
            try {
                const response = await this.$store.dispatch('asset/printQRCode', asset_id)
                window.open(URL.createObjectURL(response))
            } catch (e) {
                this.displayError(e)
            } finally {
                this.loading = false
            }
        },
        async reloadQrCode() {
            const asset_id = this.$route.params.id
            this.loading = true
            try {
                const result = await this.$store.dispatch('asset/reloadQRCode', asset_id)
                if (result && result.status === 'skipped') {
                    this.displayInfo({ message: result.message || 'File QR Code sudah ada, dilewati.' })
                } else {
                    this.displaySuccess({ message: (result && result.message) || 'QR Code berhasil digenerate.' })
                }

                const html = await this.$store.dispatch('asset/getQRCode', asset_id)
                this.qrCode = this.extractQrSrcFromHtml(typeof html === 'string' ? html : null)
            } catch (e) {
                this.displayError(e)
            } finally {
                this.loading = false
            }
        },
        extractQrSrcFromHtml(html) {
            if (!html || typeof html !== 'string') return null
            const match = html.match(/src=["']([^"']+)["']/i)
            return match ? match[1] : null
        },
        async getAsset() {
            this.loading = true
            try {
                let asset = this.$store.getters['asset/searchBarang'](this.$route.params.id)
                if (!asset) {
                    asset = await this.$store.dispatch('asset/getBarangById', this.$route.params.id)
                }
                this.asset = asset || {}

                const html = await this.$store.dispatch('asset/getQRCode', this.$route.params.id)
                this.qrCode = this.extractQrSrcFromHtml(typeof html === 'string' ? html : null)
            } catch (e) {
                this.displayError(e)
            } finally {
                this.loading = false
            }
        }
    },
    created() {
        if (!this.$route.params.id) {
            this.$router.push('/asset')
            return
        }
        this.getAsset()
    }
}
</script>
<style scoped>
#qrcode-container {
    width: 100%;
}
.asset-qr-thumb {
    cursor: pointer;
    line-height: 0;
}
.asset-qr-thumb img {
    width: 160px;
    max-width: 40vw;
    height: auto;
    display: block;
    transition: opacity 0.15s ease;
}
.asset-qr-thumb:hover img {
    opacity: 0.85;
}
.asset-qr-full {
    width: min(360px, 85vw);
    height: auto;
}
</style>
